import vulnerabilityConfirm from './mutations/vulnerability_confirm.mutation.graphql';
import vulnerabilityDismiss from './mutations/vulnerability_dismiss.mutation.graphql';
import vulnerabilityResolve from './mutations/vulnerability_resolve.mutation.graphql';
import vulnerabilityRevertToDetected from './mutations/vulnerability_revert_to_detected.mutation.graphql';

export default {
  revert: vulnerabilityRevertToDetected,
  dismiss: vulnerabilityDismiss,
  confirm: vulnerabilityConfirm,
  resolve: vulnerabilityResolve,
};
